import { render, staticRenderFns } from "./IsSampleTip.vue?vue&type=template&id=1cc29c56&scoped=true"
import script from "./IsSampleTip.vue?vue&type=script&lang=js"
export * from "./IsSampleTip.vue?vue&type=script&lang=js"
import style0 from "./IsSampleTip.vue?vue&type=style&index=0&id=1cc29c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc29c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
